import { Box, Portal, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import theme from '../../muiTheme';
import UserAvatar from '../UserAvatar/UserAvatar';
import { truncate } from '../../utils/utils';

const PopUpNotifications = () => {

    //notifications are obtained from redux store and displayed for about 5 seconds each

    const [messages, setMessages] = useState([]);
    const [notificationItem, setNotificationItem] = useState(null);
    const {popupNotification} = useSelector((state) => state.notificationsReducer);
    const {chatNotification} = useSelector((state) => state.chatUIReducer);

    useEffect(()=>{

        if(popupNotification){
            setNotificationItem(popupNotification);
        }

    }, [popupNotification]);

    useEffect(()=>{

        if(chatNotification){
            setNotificationItem(chatNotification);
        }

    }, [chatNotification]);

    useEffect(()=>{

        if(notificationItem){
            setMessages(prevValues=>[
                notificationItem,
                ...prevValues
            ]);

            //set a timer to remove the pop up notifications after 5 seconds
            console.log('seting timeout, target id:  ', notificationItem._id);
            setTimeout(()=>{

                console.log('timeout expired, messages: ', messages, ' target id: ', notificationItem._id);
                    

                setMessages(prevValues => {

                    let newArr = prevValues.filter(message => message._id !== notificationItem._id);

                    console.log('set timeout, newArr: ', newArr);

                    return newArr; 
                });

                    
                  
            }, 5000);
        }        
        

    }, [notificationItem]);


    return (
        <Portal>

            {
                
            }


            {
                messages.length > 0 &&

                <Box
                    className='popup-notfications-container'
                    sx={{
                        position: 'fixed',
                        bottom: '50px',
                        left: '50px',
                        zIndex: '1000',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        opacity: '0.95',
                        [theme.breakpoints.down('sm')] : { //this works ??? 
                            left: '5px',
                            bottom: '5px'
                        }
                    }}
                >

                    {
                        messages.map((message)=>{

                            console.log('message: ', message);


                            //create message
                            let entity = null; 
                            let chatMessageEntity = null; 

                            if(message?.postEntities?.length > 0){
                                entity = message.postEntities.length > 1 ? 'your posts' : 'your post';

                            }else if(message?.commentEntities?.length > 0){

                                entity = message.commentEntities.length > 1 ? 'your comments' : 'your comment';
                            }else if(message?.chatMessageEntities?.length > 0) {
                                chatMessageEntity = message.chatMessageEntities.length > 1 ? 'some messages' : 'a message';
                            }


                            if(message.action === 'followed'){
                                entity = 'you'
                            }

                            console.log('Entity: ', entity, ' chatMessageEntity: ', chatMessageEntity);


                            return (
                                <Box

                                    key={'popup-notification-'+message._id}
                                
                                    sx={{
                                        height: '100px',
                                        borderRadius: '10px',
                                        background: 'white',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        padding: '0px 20px',
                                        margin: '5px 0px',
                                        borderTopLeftRadius: '0px',
                                        borderBottomLeftRadius: '0px',
                                        borderLeft: '10px solid '+theme.palette.primary.main,
                                        boxShadow: '0px 9px 11px rgb(0 0 0 / 6%)'

                                    }}
                                >

                                    <UserAvatar imageURL={message.invokingUser.profileImage} url={`/profile/${message.invokingUser._id}`} />

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                            justifyContent: 'center',
                                        }}
                                    >

                                        <Typography variant='body1'>

                                            {
                                                entity &&

                                                <>
                                                    <b>{`${message.invokingUser.name}`}</b> {`${message.action} `} {` ${entity} ` }
                                                </>
                                            }

                                            {
                                                chatMessageEntity &&

                                                <>
                                                    <b>{`${message.invokingUser.name}`}</b> {`${message.action} `} {` ${chatMessageEntity} ` }
                                                </>
                                            }
                                        
                                        </Typography>
                                        
                                        {
                                            chatMessageEntity &&

                                            <Typography variant='body2' sx={{color: theme.palette.gray}}>

                                                {
                                                    truncate(message.chatMessageEntities[0].message, 25)
                                                }

                                            </Typography>

                                        }

                                    </Box>
                                    

                                </Box>
                            );
                        })
                    }

                </Box>
            }
                  

        </Portal>
    ); 
}

export default PopUpNotifications; 